(function () {
  'use strict';

  var list = document.getElementById('wholesale-order-list');
  var summary = document.getElementById('wholesale-order-summary');
  if (!list || !summary) return;

  var submitButton = summary.querySelector('[data-wholesale-submit]');
  var subtotalEl = summary.querySelector('[data-wholesale-subtotal]');
  var statusEl = summary.querySelector('[data-wholesale-status]');
  var currency = summary.getAttribute('data-currency') || 'USD';

  var formatter;
  try {
    formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency });
  } catch (e) {
    formatter = null;
  }

  function formatMoney(amount) {
    if (formatter) return formatter.format(amount);
    return '$' + amount.toFixed(2);
  }

  function rows() {
    return Array.prototype.slice.call(list.querySelectorAll('[data-wholesale-item]'));
  }

  function clampQuantity(row, rawValue) {
    var min = parseInt(row.getAttribute('data-min'), 10) || 1;
    var step = parseInt(row.getAttribute('data-step'), 10) || 1;
    var value = parseInt(rawValue, 10);

    if (isNaN(value) || value <= 0) return 0;
    if (value < min) value = min;

    var remainder = (value - min) % step;
    if (remainder !== 0) {
      value = value + (step - remainder);
    }

    return value;
  }

  function updateRow(row) {
    var checkbox = row.querySelector('[data-wholesale-check]');
    var qtyInput = row.querySelector('[data-wholesale-qty-input]');
    var lineTotalEl = row.querySelector('[data-wholesale-line-total]');
    var price = parseFloat(row.getAttribute('data-price')) || 0;
    var quantity = parseInt(qtyInput.value, 10) || 0;

    if (quantity > 0 && !checkbox.checked) {
      checkbox.checked = true;
    } else if (quantity === 0 && checkbox.checked) {
      checkbox.checked = false;
    }

    if (checkbox.checked && quantity > 0) {
      lineTotalEl.textContent = formatMoney(price * quantity);
    } else {
      lineTotalEl.textContent = '—';
    }
  }

  function refreshSummary() {
    var subtotal = 0;
    var anySelected = false;

    rows().forEach(function (row) {
      var checkbox = row.querySelector('[data-wholesale-check]');
      var qtyInput = row.querySelector('[data-wholesale-qty-input]');
      var price = parseFloat(row.getAttribute('data-price')) || 0;
      var quantity = parseInt(qtyInput.value, 10) || 0;

      if (checkbox.checked && quantity > 0) {
        subtotal += price * quantity;
        anySelected = true;
      }
    });

    subtotalEl.textContent = formatMoney(subtotal);
    submitButton.disabled = !anySelected;
  }

  function setQuantity(row, value) {
    var qtyInput = row.querySelector('[data-wholesale-qty-input]');
    var clamped = clampQuantity(row, value);
    qtyInput.value = clamped;
    updateRow(row);
    refreshSummary();
  }

  list.addEventListener('click', function (event) {
    var decreaseBtn = event.target.closest('[data-wholesale-qty-decrease]');
    var increaseBtn = event.target.closest('[data-wholesale-qty-increase]');
    if (!decreaseBtn && !increaseBtn) return;

    var row = event.target.closest('[data-wholesale-item]');
    if (!row) return;

    var qtyInput = row.querySelector('[data-wholesale-qty-input]');
    var step = parseInt(row.getAttribute('data-step'), 10) || 1;
    var min = parseInt(row.getAttribute('data-min'), 10) || 1;
    var current = parseInt(qtyInput.value, 10) || 0;

    if (increaseBtn) {
      current = current === 0 ? min : current + step;
    } else if (decreaseBtn) {
      current = current - step;
      if (current < min) current = 0;
    }

    setQuantity(row, current);
  });

  list.addEventListener('change', function (event) {
    var row = event.target.closest('[data-wholesale-item]');
    if (!row) return;

    if (event.target.matches('[data-wholesale-qty-input]')) {
      setQuantity(row, event.target.value);
    }

    if (event.target.matches('[data-wholesale-check]')) {
      var qtyInput = row.querySelector('[data-wholesale-qty-input]');
      if (event.target.checked && (parseInt(qtyInput.value, 10) || 0) === 0) {
        var min = parseInt(row.getAttribute('data-min'), 10) || 1;
        setQuantity(row, min);
      } else if (!event.target.checked) {
        setQuantity(row, 0);
      }
    }
  });

  submitButton.addEventListener('click', function () {
    var items = [];

    rows().forEach(function (row) {
      var checkbox = row.querySelector('[data-wholesale-check]');
      var qtyInput = row.querySelector('[data-wholesale-qty-input]');
      var quantity = parseInt(qtyInput.value, 10) || 0;

      if (checkbox.checked && quantity > 0) {
        items.push({
          id: row.getAttribute('data-variant-id'),
          quantity: quantity
        });
      }
    });

    if (items.length === 0) return;

    submitButton.disabled = true;
    submitButton.textContent = 'Adding to cart…';
    statusEl.textContent = '';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error((data && data.description) || 'Something went wrong adding these items to your cart.');
          });
        }
        return response.json();
      })
      .then(function () {
        statusEl.textContent = 'Added to cart.';
        window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/') + 'cart';
      })
      .catch(function (error) {
        statusEl.textContent = error.message || 'Something went wrong adding these items to your cart.';
        submitButton.disabled = false;
        submitButton.textContent = 'Add selected to cart';
      });
  });

  rows().forEach(updateRow);
  refreshSummary();
})();
